import React from 'react';
import { useTranslation } from '@shared/core';
import { ButtonV2, Flex, TextV2 } from '@withjoy/joykit';

export const NeedAssistance: React.FC = () => {
  const { t2 } = useTranslation('sharedRegistry');
  const { needAssistance, contactUs } = t2('creditCardSetUpDialog');
  return (
    <Flex
      rowGap={3}
      alignItems="center"
      justifyContent="center"
    >
      <TextV2
        typographyVariant="body1"
        color="mono14"
        marginRight={1}
      >
        {needAssistance}
      </TextV2>
      <ButtonV2
        variant="link"
        intent="neutral"
        size="sm"
        as="a"
        href="mailto:support@withjoy.com"
        typographyVariant="body1"
        fontWeight="bold"
      >
        {contactUs}
      </ButtonV2>
    </Flex>
  );
};
